import { render } from "./MyArticles.vue?vue&type=template&id=1d766988&scoped=true"
import script from "./MyArticles.vue?vue&type=script&lang=js"
export * from "./MyArticles.vue?vue&type=script&lang=js"

import "./MyArticles.vue?vue&type=style&index=0&id=1d766988&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d766988"]])

export default __exports__